import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { LoadingState } from '@ridemaadi/ui';
import { useNoIndexPage } from '../../features/public/useNoIndexPage';
import { useAuth } from '../../providers/AuthProvider';

/** Gate authenticated routes; redirect to /login preserving the return path. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  useNoIndexPage();
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingState label="Checking your session…" />;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
